export default "__VITE_ASSET__2e3ef3d3__"